import React from 'react';
import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from '../../config/navItems';
import NavIcon from './NavIcon';

export default function LudiBottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-around h-16 px-1 bg-[var(--ludi-nb)] border-t border-[var(--ludi-nb-b)] backdrop-blur-ludi pb-[env(safe-area-inset-bottom,0px)]">
      <div className="max-w-app mx-auto w-full flex justify-around">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 min-w-[52px] min-h-touch-lg justify-center relative ${
                isActive ? 'text-[var(--ludi-ni-on)]' : 'text-ludi-t30'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-7 h-[2px] rounded-b-sm bg-[var(--ludi-ni-on)]" />
                )}
                <NavIcon name={item.icon} />
                <span className="text-[9.5px] font-bold uppercase tracking-wider">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
